import {useEffect} from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import {getState, setState} from '../store';

import MainLayout from '../../layouts/MainLayout';

import AuthLoginPage from '../../screens/authLogin';
import AuthVerifyEmailPage from '../../screens/authVerifyEmail';
import ReliefStaffListPage from '../../screens/staffs';
import ReliefStaffProfilePage from '../../screens/staffProfile';
import JobPostingPage from '../../screens/jobs';
import JobCreatePage from '../../screens/jobCreate';
import JobDetailsPage from '../../screens/jobDetails';
import CentreListPage from '../../screens/centres';
import CentreDetailsPage from '../../screens/centreDetails';
import PayrollListPage from '../../screens/payrolls';
import PCFStaffListPage from '../../screens/pcfStaffs';
import PCFStaffCreatePage from '../../screens/pcfStaffCreate';
import PCFStaffProfilePage from '../../screens/pcfStaffProfile';
import NotificationListPage from '../../screens/notifications/NotificationList';
import NotificationCreatePage from '../../screens/notificationCreate';
import NotificationDetailsPage from '../../screens/notificationDetails';
import TimesheetListPage from '../../screens/timesheets';
import NotFoundPage from '../../screens/notfound';

export function RootStack() {
  const isRemember = getState().secure.isRemember;
  useEffect(() => {
    if (!isRemember && sessionStorage.getItem('loggedIn') !== 'true') {
      setState({user: {}, profile: {}, secure: {}});
    }
  }, []);

  return (
    <Router>
      <Routes>
        {/* <AuthRoute {...gsp('/login')} />
        <AuthRoute {...gsp('/verify-email')} />
        <MainRoute {...gsp('/relief-staffs')} />
        <MainRoute {...gsp('/relief-staffs/:id')} />
        <MainRoute {...gsp('/jobs')} />
        <MainRoute {...gsp('/jobs/create-job-posting')} />
        <MainRoute {...gsp('/jobs/:id')} />
        <MainRoute {...gsp('/centres')} />
        <MainRoute {...gsp('/centres/:id')} />
        <MainRoute {...gsp('/payrolls')} />
        <MainRoute {...gsp('/pcf-staffs')} />
        <MainRoute {...gsp('/pcf-staffs/create-pcf-staff-profile')} />
        <MainRoute {...gsp('/pcf-staffs/:id')} />
        <MainRoute {...gsp('/notifications')} />
        <MainRoute {...gsp('/notifications/create-new-notification')} />
        <MainRoute {...gsp('/notifications/:id')} />
        <MainRoute {...gsp('/timesheets')} />
        <Route {...gsp('/notfound')} path="*" /> */}
        <Route path="/login" element={<AuthLoginPage />} />
        <Route path="/verify-email" element={<AuthVerifyEmailPage />} />
        <Route
          path="/relief-staffs"
          element={
            <MainLayout>
              <ReliefStaffListPage />
            </MainLayout>
          }
        />
        <Route
          path="/relief-staffs/:id"
          element={
            <MainLayout>
              <ReliefStaffProfilePage />
            </MainLayout>
          }
        />
        <Route path="/" element={<Navigate to="/jobs" replace />} />
        <Route
          path="/jobs"
          element={
            <MainLayout>
              <JobPostingPage />
            </MainLayout>
          }
        />
        <Route
          path="/jobs/create-job-posting"
          element={
            <MainLayout>
              <JobCreatePage />
            </MainLayout>
          }
        />
        <Route
          path="/jobs/:id"
          element={
            <MainLayout>
              <JobDetailsPage />
            </MainLayout>
          }
        />
        <Route
          path="/centres"
          element={
            <MainLayout>
              <CentreListPage />
            </MainLayout>
          }
        />
        <Route
          path="/centres/:id"
          element={
            <MainLayout>
              <CentreDetailsPage />
            </MainLayout>
          }
        />
        <Route
          path="/payrolls"
          element={
            <MainLayout>
              <PayrollListPage />
            </MainLayout>
          }
        />

        <Route
          path="/pcf-staffs"
          element={
            <MainLayout>
              <PCFStaffListPage />
            </MainLayout>
          }
        />
        <Route
          path="/pcf-staffs/create-pcf-staff-profile"
          element={
            <MainLayout>
              <PCFStaffCreatePage />
            </MainLayout>
          }
        />
        <Route
          path="/pcf-staffs/:id"
          element={
            <MainLayout>
              <PCFStaffProfilePage />
            </MainLayout>
          }
        />
        <Route
          path="/notifications"
          element={
            <MainLayout>
              <NotificationListPage />
            </MainLayout>
          }
        />
        <Route
          path="/notifications/create-new-notification"
          element={
            <MainLayout>
              <NotificationCreatePage />
            </MainLayout>
          }
        />
        <Route
          path="/notifications/:id"
          element={
            <MainLayout>
              <NotificationDetailsPage />
            </MainLayout>
          }
        />
        <Route
          path="/timesheets"
          element={
            <MainLayout>
              <TimesheetListPage />
            </MainLayout>
          }
        />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}
